module.exports = __webpack_public_path__ + "img/bj_yaokong_zuo@2x.d144467f.png";